module.exports = __webpack_public_path__ + "img/sk_title.22bebd88.jpg";